import React, { useMemo, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import LoginDialog from './Login';
import { useNavigate } from 'react-router-dom';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth, db } from '../firebase';
import PopupState, { bindMenu, bindTrigger } from 'material-ui-popup-state';
import { collection, onSnapshot, query } from 'firebase/firestore';

function AdminNavbar() {
  const navigate = useNavigate();
  const [user, authLoading, error] = useAuthState(auth);
  const [anchorElNav, setAnchorElNav] = useState(null);
  const [pages, setPages] = useState([
      {
        name: 'Que',
        href: '/que',
      },
      {
        name: 'Customers',
        href: '/customer-info',
      },
      {
        name: 'Stats',
        href: '/stats',
      },
      {
        name: 'Calendar',
        href: '/calendar',
      },
      {
        name: 'Tickets',
        href: '/tickets',
      },
      {
        name: 'Ticket Admin',
        href: '/ticket-admin',
      },
      {
        name: 'Terminal',
        href: '/terminals',
      },
      {
        name: 'QR',
      },
      {
        name: 'Join',
      },
      {
        name: 'Coupon',
        href: '/coupon',
      },
      {
        name: 'Vouchers',
        href: '/vouchers',
      },
      {
        name: 'Gift Cards',
        href: '/gift-cards',
      },
      {
        name: 'Settings',
        href: '/settings',
      },
      {
        name: 'Schedule',
        href: '/schedule',
      }
    ]
  );

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };


  const handleCloseNavMenu = (page) => {
    setAnchorElNav(null);
  };

  useMemo(() => {
    onSnapshot(query(collection(db, 'locations')), (querySnapshot) => {
      const list = [];
      querySnapshot.forEach((doc) => {
        list.push({ ...doc.data(), id: doc.id });
      });

      setPages(pages => {
        const newPages = [...pages];
        newPages.find(p => p.name === "QR").hrefs = list.map(location => ({
          name: location.name,
          url: `/qr/${location.id}`
        }));
        newPages.find(p => p.name === "Join").hrefs = list.map(location => ({
          name: location.name,
          url: `/join/${location.id}`
        }));
        return newPages;
      });
    });
  }, []);


  return user && (
    <AppBar position="static">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          {/* Mobile */}
          <Box sx={{ flexGrow: 1, display: { md: 'flex', lg: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { md: 'block', lg: 'none' },
              }}
            >
              {pages.map((page) => (
                page.hrefs ?
                // Submenu multiple pages
                <PopupState key={page.name + "_mobile"} variant="popover" popupId={page.name + "_mobile"}>
                  {(popupState) => (
                    <React.Fragment>
                      <MenuItem {...bindTrigger(popupState)}>
                        {page.name}
                      </MenuItem>
                      <Menu {...bindMenu(popupState)}>
                        {page.hrefs.map((href) => (
                          <MenuItem key={"mobile" + href.name} onClick={() => {
                            navigate(href.url);
                            popupState.close();
                          }}>{href.name}</MenuItem>
                        ))}
                      </Menu>
                    </React.Fragment>
                  )}
                </PopupState>
                :
                // Single page
                <MenuItem key={page.name} onClick={() => {
                  navigate(page.href);
                }}>
                  <Typography textAlign="center">{page.name}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Dekstop */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none',  md: 'none', lg: 'flex' } }}>
            {pages.map((page) => (
                page.hrefs ?
                // Submenu multiple pages
                <PopupState key={page.name + "_desktop"} variant="popover" popupId={page.name + "_desktop"}>
                  {(popupState) => (
                    <React.Fragment>
                      <MenuItem {...bindTrigger(popupState)}>
                        {page.name}
                      </MenuItem>
                      <Menu {...bindMenu(popupState)}>
                        {page.hrefs.map((href) => (
                          <MenuItem key={"desktop" + href.name} onClick={() => {
                            navigate(href.url);
                            popupState.close();
                          }}>{href.name}</MenuItem>
                        ))}
                      </Menu>
                    </React.Fragment>
                  )}
                </PopupState>
                :
                // Single page
                <Button
                  key={page.name}
                  onClick={() => {
                    navigate(page.href);
                  }}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  {page.name}
                </Button>
              ))}
          </Box>
          <LoginDialog isOpen={false} hidden={false} />
        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default AdminNavbar;
